import * as types from "../actionTypes/RatActionTypes";
import axios from "../../Uri";
import * as api from "../api/api";
export const getAllBuildingsData = (data) => ({
  type: types.GET_ALL_BUILDINGS,
  payload: data,
});
export const successCallResponse = (status) => ({
  type: types.SUCCESS_RESPONSE,
  payload: status,
});
export const failureCallResponse = (status) => ({
  type: types.FAILURE_RESPONSE,
  payload: status,
});
export const getAllBuildings = () => (dispatch) => {
  axios
    .get(`bed/getAllBuildings`)
    .then((res) => {
      dispatch(getAllBuildingsData(res.data));
      dispatch(successCallResponse(true));
    })
    .catch((error) => {
      console.log(error);
      dispatch(failureCallResponse(false));
    });
};
export const getManagerBuilding = (buildingId) => (dispatch) => {
  axios
    .get(`bed/getBuildingsById/${buildingId}`)
    .then((response) => {
      dispatch({ type: types.GET_MANAGER_BUILDING, payload: response.data });
      dispatch(successCallResponse(true));
    })
    .catch((err) => {
      console.log(err.data);
      dispatch(failureCallResponse(false));
    });
};
export const getBedSummaryForPieChartByBuildingId =
  (buildingId) => (dispatch) => {
    axios
      .get(`bed/getBedSummaryForPieChartByBuildingId/${buildingId}`)
      .then((response) => {
        dispatch({ type: types.BED_SUMMARY_PIECHART, payload: response.data });
        dispatch(successCallResponse(true));
      })
      .catch((err) => {
        console.log(err.data);
        dispatch(failureCallResponse(false));
      });
  };
export const getBedsByBuildingId = (buildingId) => (dispatch) => {
  axios
    .get(`bed/getBedsByBuildingId/${buildingId}`)
    .then((response) => {
      console.log(response.data);
      dispatch({ type: types.GET_BEDS_BY_BUILDINGID, payload: response.data });
      dispatch({ type: types.LOADING, payload: true });
    })
    .catch((error) => {
      console.log(error);
      dispatch(failureCallResponse(false));
      dispatch({ type: types.LOADING, payload: false });
    });
  return status;
};
export const getBedsByColorFilter =
  (buildingId, colorFilterType,status) => (dispatch) => {
    console.log("Color" ,buildingId, colorFilterType,status)
    dispatch({ type: types.LOADING, payload: false });
    axios
      .get(
        `bed/getavailBedsByBuildingIdSquaresInRat/${buildingId}/${colorFilterType}?occupencyType=s`
      )
      .then((response) => {
        console.log(response)
        dispatch({
          type: types.GET_BEDS_BY_COLOR_FILTERS,
          payload: response.data.body,
        });
        dispatch({ type: types.LOADING, payload: true });
      })
      .catch((err) => {
        console.log(err);
        dispatch(failureCallResponse(false));
      });
  };
export const getAvaibleBedsByBuildingId = (id) => (dispatch) => {
  console.log(id);
  axios
    .get(`bed/getAvailableBedsByBuildingId/${id}`)
    .then((res) => {
      console.log(res.data);
      dispatch({ type: types.AVAILABEL_BEDSBY_BUILDINGID, payload: res.data });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getBedInfosRegular = (gid, id, bedId) => (dispatch) => {
  axios
    .get(`guest/getBedInfoForBedChange/${gid}/${id}/${bedId}`)
    .then((res) => {
      console.log(res.data);
      dispatch({ type: types.GET_BEDINFO, payload: res.data.data });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getBedInfoDailyorMonthly = (gid, id, bedId) => (dispatch) => {
  axios
    .get(`guest/BedChangeForDailyAndMonthly/${gid}/${id}/${bedId}`)
    .then((res) => {
      console.log(res);
      dispatch({ type: types.GET_BEDINFO, payload: res.data.data });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const finishBedChangeForRegular = (info) => (dispatch) => {
  axios
    .put(`guest/finishBedChange/${info.guestId}`, info)
    .then((res) => {
      console.log(res);
      dispatch({ type: types.CHANGE_BED, payload: res.data });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const finishBedChangeForDailyandMonthly = (gid) => (dispatch) => {
  axios
    .put(`guest/finishBedChangeForDailyAndMonthly/${gid.guestId}`, gid)
    .then((res) => {
      console.log(res);
      dispatch({ type: types.CHANGE_BED, payload: res.data });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const forceCheckout = (id, data) => (dispatch) => {
  axios
    .put(`guest/forceCheckout/${id}`, data)
    .then((res) => {
      console.log(res);
      dispatch({ type: types.FORCE_CHECKOUT, payload: res.data });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const editDueAmount = (id, data) => (dispatch) => {
  console.log(data.dueAmount);
  axios
    .put(`guest/updateDue/${id}?dueAmount=${data.dueAmount}`)
    .then((res) => {
      console.log(res);
      dispatch({ type: types.EDIT_DUE, payload: res.data });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const buildingSummary = (id) =>(dispatch)=> {
  axios
    .get(`/bed/getBuildingSummaryForPieChartByBuildingId/${id}`)
    .then((res) => {
      dispatch({type:types.BUILDING_SUMMARY,payload:res})
    })
    .catch((err) => {
      console.log(err);
    });
};
export const cancelCheckout = (guestId)=>(dispatch)=>{
  api.cancelCheckout(guestId).then((res)=>{
    dispatch({type: types.CANCEL_CHECKOUT,payload:res.data})
  }).catch((err)=>{
  });
}
export const makeFalse=()=>(dispatch)=>{
  dispatch({type:types.MAKE_FALSE})

}
